import { useEffect, useState } from 'react'
import { useSelector } from '@/store'
import { getTemplateInfo } from '@/services/api'

export const useTemplateInfo = (taskType, visible) => {
  const [templateInfo, setTemplateInfo] = useState(null)
  const language = useSelector((state) => state.language.languageType)

  useEffect(() => {
    if (visible) {
      getTemplateInfo({ language, taskType }).then(({ code, data }) => {
        if (code === 'SUCCESS') {
          setTemplateInfo(data)
        }
      })
    }
  }, [language, taskType, visible])

  return templateInfo
}
